import { render, staticRenderFns } from "./tableOtherMissions.vue?vue&type=template&id=71c4d63a"
import script from "./tableOtherMissions.vue?vue&type=script&lang=js"
export * from "./tableOtherMissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports